import type { AnalyzeChartFeedbackPeakParams } from '@/entities/chart';
import type { AnalyzeFeedbackPeakParams } from '@/entities/feedback';
import { FEEDBACK_COLUMNS } from '@/types/filterKeyConst';

export type FeedbackPeakAnalysisRequest =
  | {
      type: 'filter';
      params?: AnalyzeFeedbackPeakParams;
    }
  | {
      type: 'chart-cell';
      workspaceAlias: string;
      params: AnalyzeChartFeedbackPeakParams;
    };

export type FeedbackPeakAnalysisOptions = {
  chartName?: string;
  filterSet: StructuredFilter;
  frequency?: number | null;
  autoStart?: boolean;
};

export const isTimeSeriesPeakAnalysisFilterSet = (
  peakAnalysis?: FeedbackPeakAnalysisOptions,
): peakAnalysis is FeedbackPeakAnalysisOptions => {
  const filterSet = peakAnalysis?.filterSet;

  return Boolean(
    peakAnalysis?.frequency != null &&
      filterSet &&
      typeof filterSet[FEEDBACK_COLUMNS.DATE_START] === 'string' &&
      typeof filterSet[FEEDBACK_COLUMNS.DATE_END] === 'string',
  );
};
